import React, { useCallback, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { FiArrowLeftCircle, FiSearch } from 'react-icons/fi';
import TextField from '@material-ui/core/TextField';
import MobileDatePicker from '@material-ui/lab/DatePicker';

import { Container, Info, Filtro, Tabela } from './styles';

import NavBar from '../../components/NavBar';
import Header from '../../components/Header';
import Button from '../../components/Button';
import Caixas from '../../components/Relatorios/Caixas';
import Vendas from '../../components/Relatorios/Vendas';
import Cancelamentos from '../../components/Relatorios/Cancelamentos';
import VendasPorProduto from '../../components/Relatorios/VendasProduto';
import VendasPorTurno from '../../components/Relatorios/VendasTurno';

const relatorios = [
  { id: 0, nome: 'CAIXAS' },
  { id: 1, nome: 'VENDAS' },
  { id: 2, nome: 'CANCELAMENTOS' },
  { id: 3, nome: 'VENDAS POR PRODUTOS' },
  { id: 4, nome: 'VENDAS POR TURNO' },
];

const Relatorio: React.FC = () => {
  const [nome, setNome] = useState('');
  const [id, setID] = useState<number>(0);
  const [dataInicial, setDataInicial] = useState<Date>(new Date());
  const [dataFinal, setDataFinal] = useState<Date>(new Date());

  const lista = [
    <Caixas
      dt_inicial={dataInicial.toISOString().slice(0, 10)}
      dt_final={dataFinal.toISOString().slice(0, 10)}
    />,
    <Vendas
      dt_inicial={dataInicial.toISOString().slice(0, 10)}
      dt_final={dataFinal.toISOString().slice(0, 10)}
    />,
    <Cancelamentos
      dt_inicial={dataInicial.toISOString().slice(0, 10)}
      dt_final={dataFinal.toISOString().slice(0, 10)}
    />,
    <VendasPorProduto
      dt_inicial={dataInicial.toISOString().slice(0, 10)}
      dt_final={dataFinal.toISOString().slice(0, 10)}
    />,
    <Button />,
  ];
  const history = useHistory();

  useEffect(() => {
    const idLocalStorage = localStorage.getItem('@MeuPantera:idRelatorio');
    if (idLocalStorage) {
      setID(parseInt(idLocalStorage, 10));
      setNome(relatorios[id].nome);
    }
  }, [id]);

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleDataInicial = useCallback((newValue) => {
    setDataInicial(newValue);
  }, []);

  const handleDataFinal = useCallback((newValue) => {
    setDataFinal(newValue);
  }, []);

  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />
        <Info>
          <FiArrowLeftCircle size={36} color="#2c73e9" onClick={handleGoBack} />
          <h1>{nome}</h1>
        </Info>
        <Filtro>
          <MobileDatePicker
            disableFuture
            label="Data Inicial"
            inputFormat="dd/MM/yyyy"
            toolbarPlaceholder="Data Inicial"
            cancelText="Cancelar"
            value={dataInicial}
            onChange={(newValue) => handleDataInicial(newValue)}
            renderInput={(props) => <TextField {...props} />}
          />
          <MobileDatePicker
            disableFuture
            label="Data Final"
            inputFormat="dd/MM/yyyy"
            toolbarPlaceholder="Data Final"
            cancelText="Cancelar"
            value={dataFinal}
            onChange={(newValue) => handleDataFinal(newValue)}
            renderInput={(props) => <TextField {...props} />}
          />
        </Filtro>
        <Tabela>{lista[id]}</Tabela>
      </div>
    </Container>
  );
};

export default Relatorio;
